import {Notebook} from "@models/notebook.model.ts";
import {TodoList} from "@models/todo_list.model.ts"
import {Organization} from "@models/organization.model.ts";
import {TeamMember} from "@models/teamMember.model.ts";
import {AppDate} from "../utils/date-utils/AppDate.ts";
import { Schedule } from "./Schedule.model.ts";


export class Engagement {
  id: number
  create_date: AppDate
  type: string
  name: string
  client: Organization
  schedule: Schedule
  service_provider: Organization
  engagement_manager: TeamMember
  /** The Ops Lead's counterpart. Null when nobody holds the role (MPN-1720). */
  client_success_manager: TeamMember | null
  /** When THIS user last opened it. Null means they never have. */
  last_viewed: AppDate | null
  update_date: AppDate | null
  /** Campaigns with at least one network actually serving. Derived, never stored. */
  campaigns_live: number
  /** Networks serving across those campaigns, de-duplicated. Never summed per campaign. */
  live_networks: string[]
  /** Per campaign, for the hover breakdown behind the tag. */
  live_by_campaign: { campaign: string; networks: string[] }[]
  stage: string
  status: string
  is_active: boolean
  /** Hidden from clients, kept in full internally (MPN-1533). */
  is_archived: boolean
  archived_at: string | null
  todo_list: TodoList
  notebook: Notebook
  engagement_type: string
  total_todos: number
  pending_todos: number
  spend_chart_data: number[]
  impression_chart_data: number[]
  constructor() {
    this.id = -1
    this.create_date = new AppDate()
    this.type = ""
    this.name = ""
    this.client = new Organization()
    this.service_provider = new Organization()
    this.schedule = new Schedule()
    this.engagement_manager = new TeamMember()
    this.client_success_manager = null
    this.last_viewed = null
    this.update_date = null
    this.campaigns_live = 0
    this.live_networks = []
    this.live_by_campaign = []
    this.stage = ""
    this.status = "STAGING"
    this.is_active = false
    this.is_archived = false
    this.archived_at = null
    this.todo_list = new TodoList()
    this.notebook = new Notebook()
    this.engagement_type = ""
    this.total_todos = 0
    this.pending_todos = 0
    this.spend_chart_data = []
    this.impression_chart_data = []
  }
}
